// Bootstrap

import "bootstrap/js/dist/base-component";
import "bootstrap/js/dist/alert";
import "bootstrap/js/dist/button";
import "bootstrap/js/dist/carousel";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/offcanvas";
import "bootstrap/js/dist/popover";
import "bootstrap/js/dist/scrollspy";
import "bootstrap/js/dist/tab";
import "bootstrap/js/dist/toast";
import "bootstrap/js/dist/tooltip";

// var tooltipTriggerList = [].slice.call(
// 	document.querySelectorAll('[data-bs-toggle="tooltip"]')
// );
// var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
// 	return new bootstrap.Tooltip(tooltipTriggerEl);
// });

// var popoverTriggerList = [].slice.call(
// 	document.querySelectorAll('[data-bs-toggle="popover"]')
// );
// var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
// 	return new bootstrap.Popover(popoverTriggerEl);
// });


// Fancybox
import { Fancybox } from '@fancyapps/ui';
Fancybox.bind('[data-fancybox]');
Fancybox.bind('[data-fancybox="plans"]', { mainClass: 'fancybox-plans' });

// Hero Video HLS Support
function initHlsVideo(video, src) {
  if (video.canPlayType('application/vnd.apple.mpegurl')) {
    if (!video.src) video.src = src;
  } else if (window.Hls && Hls.isSupported()) {
    const hls = new Hls({ startLevel: -1, capLevelToPlayerSize: true });
    hls.loadSource(src);
    hls.attachMedia(video);
    hls.on(Hls.Events.MANIFEST_PARSED, () => video.play());
  }
}

function initHeroVideo() {
  // Background clip fade-in + HLS
  const bgVideo = document.querySelector('.hero-video-bg');
  if (bgVideo) {
    bgVideo.addEventListener('playing', () => bgVideo.classList.add('is-playing'), { once: true });
    const hlsSrc = bgVideo.dataset.hlsSrc;
    if (hlsSrc) initHlsVideo(bgVideo, hlsSrc);
  }

  // Lightbox button — open video in Fancybox
  const btn = document.querySelector('[data-hero-video]');
  if (btn) {
    btn.addEventListener('click', () => {
      const videoSrc = btn.dataset.heroVideo;
      const isHls = btn.hasAttribute('data-hero-video-hls');

      if (isHls) {
        // HLS: use inline HTML with custom video element
        Fancybox.show([{
          src: videoSrc,
          type: 'html',
          html: '<div class="hero-lightbox-video" data-hls-src="' + videoSrc + '"><video controls playsinline></video></div>',
        }], {
          on: {
            reveal: (fancybox, slide) => {
              const container = slide.el?.querySelector('.hero-lightbox-video');
              if (container) {
                const video = container.querySelector('video');
                if (video) initHlsVideo(video, videoSrc);
              }
            },
          },
        });
      } else {
        // MP4: use Fancybox's built-in html5video type
        Fancybox.show([{
          src: videoSrc,
          type: 'html5video',
          html5videoFormat: 'video/mp4',
        }]);
      }
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeroVideo);
} else {
  initHeroVideo();
}

// Custom
import InitGsap from './InitGsap';
InitGsap.init()

// WordPress Gallery Lightbox Functionality
function initGalleryLightbox() {
  const galleries = document.querySelectorAll('.wp-block-gallery');

  galleries.forEach((gallery, galleryIndex) => {
    // Get all image figures in the gallery
    const figures = gallery.querySelectorAll('figure');

    if (figures.length === 0) return;

    // Create a unique gallery group ID
    const galleryId = `gallery-${galleryIndex}`;

    // Create hidden container for all gallery images (for Fancybox)
    const hiddenGallery = document.createElement('div');
    hiddenGallery.style.display = 'none';
    hiddenGallery.className = 'hidden-gallery';

    // Add data-fancybox to all images for the lightbox
    figures.forEach((figure, imageIndex) => {
      const img = figure.querySelector('img');
      if (!img) return;

      // Create a link for Fancybox
      const link = document.createElement('a');
      link.href = img.src;
      link.setAttribute('data-fancybox', galleryId);

      // Add caption if available
      const caption = figure.querySelector('figcaption');
      if (caption) {
        link.setAttribute('data-caption', caption.textContent);
      }

      hiddenGallery.appendChild(link);

      // Make the visible images (first 4) clickable to open lightbox
      if (imageIndex < 4) {
        figure.style.cursor = 'pointer';
        figure.addEventListener('click', () => {
          // Trigger click on the corresponding hidden link to open Fancybox
          hiddenGallery.querySelectorAll('a')[imageIndex].click();
        });
      }
    });

    // Add hidden gallery to the DOM
    gallery.appendChild(hiddenGallery);

    // Create "Open Gallery" button
    const openButton = document.createElement('button');
    openButton.className = 'gallery-open-btn';
    openButton.textContent = 'Open Gallery';
    openButton.addEventListener('click', () => {
      // Open the first image in the gallery
      hiddenGallery.querySelector('a').click();
    });

    // Insert button after the gallery
    gallery.parentNode.insertBefore(openButton, gallery.nextSibling);
  });
}

// Initialize gallery lightbox when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGalleryLightbox);
} else {
  initGalleryLightbox();
}

